import React from 'react';
import {Button, Modal, Form, Col} from 'react-bootstrap';
import {Checkbox, CheckboxGroup} from '../Common';
import {Formik, Field} from 'formik';
import * as yup from 'yup';

const schema = yup.object().shape({
  isAgree: yup.boolean().required('You must agree to this!'),
});

class Message extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      show: true
    }
    this.close = this.close.bind(this);
  }

  close () {
    this.setState({show: false});
  };

  render () {
    return (
      <React.Fragment>
        <Modal show={this.state.show} centered onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.props.message}</Modal.Body>
          <Modal.Footer>
            {/* <Button className="float-left" variant="secondary" onClick={this.close}>
              {this.props.btnclosetext || 'Close'}
            </Button> */}
            <Button className="float-right" variant="primary" onClick={this.close}>
              {this.props.btnoktext || 'Ok'}
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

class PromptDialog extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      show: this.props.show || false,
      showMessage: this.props.showMessage || false
    }
    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleOk = this.handleOk.bind(this);
    this.showMessage = this.showMessage.bind(this);
  }

  componentDidMount () {
    this.props.onRef(this)
  }

  componentWillUnmount () {
    this.props.onRef(undefined)
  }

  handleShow (shouldShow) {
    this.setState({show: shouldShow, showMessage: false});
  }

  handleClose () {
    this.setState({show: false, showMessage: false});
    if (typeof this.props.onCancel === 'function')
      this.props.onCancel();
  }

  handleOk () {
    this.setState({show: false, showMessage: false});
    if (typeof this.props.onOk === 'function') {
      this.props.onOk();
    }
  }

  showMessage (messageTitle, messageBody) {
    this.setState({showMessage: true, messageTitle, messageBody});
  }

  render () {
    if (this.state.showMessage) {
      return (
        <Message title={this.state.messageTitle || this.props.messageTitle || "9 to Know"}
                 message={this.state.messageBody || this.props.messageBody}/>
      );
    }
    let {
      title,
      okText,
      cancelText
    } = this.props;

    if (!this.state.show) {
      return null;
    }
    if (this.props.onlyDialog) {
      return (
        <Modal show={this.state.show} centered onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/*{this.props.body}*/}
            {this.props.body && typeof this.props.body === 'string' &&
              this.props.body.split("\n").map((item, key) => {
                return (
                  <span key={key}>
                    {item}
                    <br/>
                    </span>
                )
              })
            }
          </Modal.Body>
          <Modal.Footer>
            <Button type="button" className='btn btn-primary float-left' style={{'marginRight': "21.8em"}}
                    onClick={this.handleClose}>
              {cancelText || "Cancel"}
            </Button>
            <button onClick={this.handleOk} className='btn btn-primary'>
              {okText || "Ok"}
            </button>
          </Modal.Footer>
        </Modal>
      );
    }
    return (
      <React.Fragment>
        {/* <Button variant="primary" onClick={handleShow}>
          Launch demo modal
        </Button> */}
        <Formik
          validateOnChange={false}
          validateOnBlur={false}
          initialValues={{isAgree: this.props.isAgree}}
          validationSchema={schema}
          onSubmit={this.handleOk}
          enableReinitialize={true}
        >
          {({
              handleSubmit,
              handleChange,
              handleBlur,
              setFieldValue,
              setFieldTouched,
              values,
              errors,
              touched,
              isSubmitting
            }) => (
            <Modal show={this.state.show} centered onHide={this.handleClose}>
              <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{'marginBottom': "-30px"}}>
                  <Form.Row>
                    <Form.Group as={Col} md="12" controlId="validationFormikPublishAgreement">
                      <CheckboxGroup
                        id="checkboxGroup"
                        label=""
                        value={values.isAgree}
                        error={errors.isAgree}
                        touched={setFieldTouched}
                        isValid={touched.isAgree && !errors.isAgree}
                        isInvalid={errors.isAgree}
                      >
                        <Field
                          component={Checkbox}
                          name="isAgree"
                          id="agreementPublish"
                          expect={'true'}
                          label="You agree to take on the added responsibility that comes from editing or changing the original text that was provided."
                          onChange={e => {
                            setFieldValue('isAgree', e.target.value);
                            setFieldTouched('isAgree', true);
                          }}
                        />
                      </CheckboxGroup>
                      <br></br>
                      <p>Once you click publish, your changes will be visible on your 9 To Know application. </p>
                    </Form.Group>
                  </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button type="button" className='btn btn-primary float-left' style={{'marginRight': "65%"}}
                          onClick={this.handleClose}>
                    {cancelText || "Cancel"}
                  </Button>
                  <button type="submit" className='btn btn-primary float-right'>
                    {okText || "Ok"}
                  </button>
                </Modal.Footer>
              </Form>
            </Modal>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

export {Message, PromptDialog};
